import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import windowSize from 'react-window-size';

class View extends Component {
  getSteps() {
    return [
      {
        path: 'index',
        name: 'お申込み内容入力',
      },
      {
        path: 'confirm',
        name: '確認',
      },
      !this.props.stripeEnabled ? undefined : {
        path: 'credit',
        name: 'お支払い',
      },
      {
        path: 'thanks',
        name: '完了',
      },
    ].filter((x) => x !== undefined);
  }

  splitIfSmartPhone(text) {
    const { windowWidth } = this.props;
    const SCREEN_SM = 576;
    const texts = [...text];
    if (windowWidth > SCREEN_SM || texts.length < 5) {
      return text;
    }
    texts.splice(-2, 0, <br />);
    return (
      texts.map((x) => <React.Fragment key={x}>{x}</React.Fragment>)
    );
  }

  render() {
    const { current } = this.props;
    let notCompleted = false;
    return this.getSteps().map((x) => {
      const result = (<li key={x.path} className={!notCompleted ? 'current' : null}>{this.splitIfSmartPhone(x.name)}</li>);
      if (x.path === current) {
        notCompleted = true;
      }
      return result;
    });
  }
}

View.defaultProps = {
  stripeEnabled: true,
};

View.propTypes = {
  current: PropTypes.string.isRequired,
  stripeEnabled: PropTypes.bool,
  windowWidth: PropTypes.number.isRequired,
};

export default connect(null, null)(windowSize(View));
